import * as React from 'react';
import IndividualContact from "../../../model/contact/IndividualContact";
import Routes from "../../../navigation/route/Route";
import {RouteComponentProps, withRouter} from "react-router";
import TableOrderIndicator from "../../ui/table/TableOrderIndicator";
import {PartnerBrandSearch} from "../../../model/partnerBrand/PartnerBrand";
import Checkbox from "../../../hiberUiKit/src/atoms/Checkbox/Checkbox";
import {Option} from "ts-option";
import Loading from "../../ui/loading/Loading";

export interface DetailedContact {
	contact: IndividualContact,
	partnerBrand: Option<PartnerBrandSearch>;
}

interface ComponentProps {
	/**
	 * Individual contacts.
	 */
	detailedContacts: DetailedContact[];
}

interface State {
	/**
	 * Flag if sort order (by name) is ascending.
	 */
	sortOrderAsc: boolean;
	/**
	 * Sorted detailed contacts.
	 */
	sortedDetailedContacts: DetailedContact[];
}

type Props = RouteComponentProps<any> & ComponentProps;

class IndividualContactsTable extends React.Component<Props, State> {
	constructor(props: Props) {
		super(props);
		this.state = {sortOrderAsc: true, sortedDetailedContacts: this.sortContacts(props.detailedContacts, true)}
	}

	componentWillReceiveProps(nextProps: Props) {
		this.setState({sortedDetailedContacts: this.sortContacts(nextProps.detailedContacts, this.state.sortOrderAsc)})
	}

	render() {
		return (
			<table className="l-table-default table-hover">
				<thead>
				<tr>
					<th className={"a-pointer"} onClick={this.onSortOrderChange}>
						Name {<TableOrderIndicator isAsc={this.state.sortOrderAsc}/>}
					</th>
					<th>Emails</th>
					<th>Phones</th>
					<th>Partner Brand</th>
					<th>Archived</th>
				</tr>
				</thead>
				<tbody>
				{this.state.sortedDetailedContacts.map((dc, index) => {
					return <tr key={index} onClick={() => this.onClick(dc.contact.id)} style={{cursor: "pointer"}}>
						<td>{dc.contact.data.displayName()}</td>
						<td>
							{dc.contact.data.communication.emails.getOrElse([]).map(
								(email, index) => <div key={index}>{`${email.value}${!email.valid ? " (Invalid)" : ""}`}</div>)}
						</td>
						<td>
							{dc.contact.data.communication.phoneNumbers.getOrElse([]).map(
								(pn, index) => <div key={index}>
									{`${pn.nationalPhoneNumber} (${pn.valid.get ? pn.type.getOrElse("").toLowerCase() :
										"Invalid"})`}
								</div>)}
						</td>
						<td>
							<Loading isLoading={dc.contact.data.partnerBrandId.isDefined && dc.partnerBrand.isEmpty} spinnerSize={24}>
								{dc.partnerBrand.map(pb => pb.name).orNull}
							</Loading>
						</td>
						<td style={{paddingLeft: "35px"}}><Checkbox checked={dc.contact.data.archived} disabled={true}/></td>
					</tr>
				})}
				</tbody>
			</table>
		);
	}

	/**
	 * On tile click.
	 * @param {string} contactId Contact identifier.
	 */
	onClick(contactId: string) {
		this.props.history.push(Routes.EditContact(contactId));
	}

	/**
	 * Sort order change callback.
	 */
	onSortOrderChange = () => {
		const sortOrderAsc = !this.state.sortOrderAsc;
		this.setState({sortOrderAsc, sortedDetailedContacts: this.sortContacts(this.props.detailedContacts, sortOrderAsc)});
	};

	/**
	 * Sort detailedContacts by display name.
	 * @param {DetailedContact[]} detailedContacts
	 * @param {boolean} isAscending
	 * @returns {DetailedContact[]}
	 */
	sortContacts(detailedContacts: DetailedContact[], isAscending: boolean) {
		const sortedDetailedContacts = detailedContacts.sort((a, b) => IndividualContact.sortByName(a.contact, b.contact));
		if (isAscending) {
			return sortedDetailedContacts;
		}
		return sortedDetailedContacts.reverse();

	}
}

export default withRouter<ComponentProps>(IndividualContactsTable);
